<template>
  <div>
    <v-card-text class="mt-2">
      Vill du återaktivera händelsen: <strong>{{ item.title }}</strong
      >?
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer />
      <v-btn rounded @click="closeModal" :disabled="updatePending"
        >Avbryt</v-btn
      >
      <v-btn
        rounded
        @click="onReEnable"
        color="primary"
        :loading="updatePending"
      >
        Återaktivera
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: 'HistoryEventReEnableModal',

  props: {
    item: Object,
    refetch: Function
  },

  data: () => ({
    updatePending: false
  }),

  methods: {
    async onReEnable() {
      this.updatePending = true

      const { data } = await this.$apollo.mutate({
        mutation: gql`
          mutation($payload: PatchEventInput!) {
            patchEvent(payload: $payload) {
              event {
                uuid
                title
                time_start
                district_id
                comment
                basun
                location
                basun_time
                last_dua_message {
                  created
                  body {
                    response_data
                    trip_uuid
                    data
                  }
                }
                last_sms_message {
                  uuid
                  event_uuid
                  trips {
                    trip_uuid
                    data {
                      bookings {
                        first_name
                        last_name
                        phone_number
                        train_number
                        departure_date
                        time_start
                        time_end
                        place_start
                        place_end
                      }
                    }
                  }
                }
                sms_messages {
                  uuid
                  event_uuid
                  trips {
                    trip_uuid
                    data {
                      bookings {
                        first_name
                        last_name
                        phone_number
                        train_number
                        departure_date
                        time_start
                        time_end
                        place_start
                        place_end
                      }
                    }
                  }
                }
                last_traffic_message {
                  created
                  event_uuid
                  subject
                  routes
                  delays
                  replacements
                  yellow_vests
                  train_deviations
                  turnarounds
                  forecast_comment
                  replacement_comment
                  yellow_vest_comment
                  consequence
                }
                routes {
                  uuid
                  from_place
                  to_place
                }
                reason {
                  name
                  uuid
                }
                operation_level {
                  uuid
                  name
                }
              }
            }
          }
        `,
        variables: {
          payload: {
            uuid: this.item.uuid,
            patch: {
              archived: false
            }
          }
        }
      })
      this.$store.set(`event/data@${this.item.uuid}`, data.patchEvent.event)
      await this.refetch()
      this.updatePending = false
      this.closeModal()
    },

    closeModal() {
      this.$emit('close')
    }
  }
}
</script>
